import { NSARouterMakerResult } from "namirasoft-account-react";
import { AssetRow } from "namirasoft-balance";
import { NSLoading } from "namirasoft-site-react";
import { ReactNode, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BalanceRouterProps } from "../BalanceRouterProps";

interface AssetProviderProps extends NSARouterMakerResult, BalanceRouterProps
{
    render: (asset: AssetRow) => ReactNode;
}

export function AssetProvider(props: AssetProviderProps)
{
    const { asset_id } = useParams();
    const [asset, setAsset] = useState<AssetRow | null>(null);

    useEffect(() =>
    {
        let cancelled = false;
        props.servers.balance.asset.Get(asset_id ?? "").then(a =>
        {
            if (!cancelled)
                setAsset(a);
        });
        return () => { cancelled = true; };
        // servers.balance is recreated on every Router render, so depending on it refetches endlessly
        // eslint-disable-next-line
    }, [asset_id]);

    if (asset === null)
        return <NSLoading title="Loading asset..." />

    return (
        <>
            {props.render(asset)}
        </>
    );
}